import { submitSecurityCodeActivation } from '../../../controllers/RegisterController';

import Store from '../../../stores/Store';
import { route } from 'preact-router';

import { GlobalState } from '../../../states/global-state';
import { showAlert, showSpinner, hideSpinner } from '../../../utils';
import { Emit } from 'src/components/socket';

const store = new Store();

export async function submit(security_code) {
  showSpinner();

  const response: {
    data?: {
      code?: number;
      user?: object;
      kyc?: object;
      info?: string;
    };
    info?: string;
    code?: number;
  } = await submitSecurityCodeActivation({
    token: store.get('token'),
    reset_code: security_code,
    email: store.get('email'),
  });

  await hideSpinner();

  const responseCode = response.code || response.data.code;

  if (responseCode == 0) {
    return showAlert({
      title: 'Error',
      text: response.info || response.data.info,
      icon: 'error',
    });
  } else if (responseCode == 2) {
    route('/signup/notify', true);
  } else if (responseCode == 1) {
    showAlert({
      title: 'Success',
      text: 'success',
      icon: 'success',
    });

    const respon = response.data;

    const user: {
      id?: string;
      email?: string;
      token?: string;
      pin?: string;
      userStatus?: string;
    } = respon.user;
    const kyc: {
      id?: string;
      firstName?: string;
      viewOnly?: boolean;
    } = respon.kyc;

    store.put('lang', 'ID');
    store.put('userid', user.id);
    store.put('email', user.email);
    store.put('token', user.token);
    store.put('pin', user.pin || null);
    store.put('custid', kyc.id || null);
    store.put('custname', kyc.firstName || null);
    store.put('totalCart', 0);
    store.put('status', user.userStatus);
    store.put('viewonly', kyc.viewOnly);
    store.put('trx', 0);

    route('/signup/notify');
  } else {
    showAlert({
      title: 'Error',
      text: response.info || response.data.info,
      icon: 'error',
    });
    return;
  }
}
